import appConfig from '@/declis';
import { RequestAPI } from '@/api/request-api';
import standaloneFetch from '@/api/standalone-api';
import { getDecli, isStandaloneMode } from '@/helpers';

/**
 * Interact with the API based on the active decli. Contains most used API
 * calls in methods like `getSessionToken`, `getSessionCurrent`.
 * 
 * ```js
 * // Retrieve the instance from the singleton (can be placed at the top of your file)
 * const requestAPI = new CurrentRequestAPI();
 * // Use methods from the `RequestAPI` class
 * requestAPI.getSessionToken({ ...data });
 * ```
 */
export default class CurrentRequestAPI extends RequestAPI {
  /** @type {import('./request-api').RequestAPI} */
  static INSTANCE;

  constructor() {
    if (RequestAPI.INSTANCE) {
      return RequestAPI.INSTANCE;
    }

    const activeDecli = getDecli(appConfig.declis);
    const opName = appConfig.localhostStaticApi ? "numberly_testapi" : appConfig.baseName

    super(
      `${document.location.protocol}//${document.location.host}/api/v0/${opName}/${activeDecli.apiVersion}`,
      // Standalone mode: the API is emulated in the browser
      isStandaloneMode() ? standaloneFetch : undefined,
    );

    RequestAPI.INSTANCE = this;
  }
}
